import { render, staticRenderFns } from "./chatEmoji.vue?vue&type=template&id=bc566ef0&scoped=true"
import script from "./chatEmoji.vue?vue&type=script&lang=js"
export * from "./chatEmoji.vue?vue&type=script&lang=js"
import style0 from "./chatEmoji.vue?vue&type=style&index=0&id=bc566ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc566ef0",
  null
  
)

export default component.exports